// extracted by mini-css-extract-plugin
module.exports = {"container":"_201ch","content":"_1V4K8","section":"_2IkyY","sectionTitle":"_1nLsj","sectionDescription":"_2jEog","separator":"_1-Z0Y"};